import React from 'react';
import QuestionHtmlWithZoom from '../QuestionHtmlWithZoom';

interface Option {
  id: string;
  label: string;
  text: string;
  isCorrect: boolean;
  image?: string;
  imageWidth?: number;
}

interface Question {
  id: string;
  type: string;
  subType?: string;
  questionTitle?: string; // 题目名称（非客观题专用，管理用）
  questionStem: string; // 题干内容（富文本，包含解析的试卷题干）
  content?: string; // 保留用于向后兼容
  options: Option[];
  score: number;
  titleImages?: string[];
  titleImageWidths?: number[];
  [key: string]: any;
}

interface QuizQuestionTitleProps {
  question: Question;
  currentIndex: number;
  examQuestions: Question[];
}

export default function QuizQuestionTitle({
  question,
  currentIndex,
  examQuestions,
}: QuizQuestionTitleProps) {
  // 判断是否为编程题，显示题目名称
  const isCodingQuestion = question?.type === 'python_coding' ||
                           question?.type === 'cpp_coding' ||
                           question?.type === 'scratch_coding';

  // 编程题题目名称：有 questionTitle 则按此内容显示，否则为空字符串（保留位置）
  const questionTitle = isCodingQuestion ? (question?.questionTitle ?? '') : null;

  // 题干内容：优先使用 questionStem（题干富文本），回退到 content（兼容旧数据）
  const questionStem = question?.questionStem || question?.content;
  const titleText = questionStem?.includes('<img') || questionStem?.startsWith('<') ? (
    <div className="prose prose-sm max-w-none">
      <QuestionHtmlWithZoom
        html={questionStem}
        imageWidths={question.titleImageWidths}
      />
    </div>
  ) : (
    <span>{questionStem}</span>
  );

  return (
    <div className="text-sm sm:text-base lg:text-lg font-medium text-gray-900 leading-relaxed">
      <div className="flex items-start gap-2">
        <span className="text-blue-600 font-bold flex-shrink-0">{currentIndex + 1}.</span>
        <div className="flex-1 min-w-0">
          {/* 编程题始终显示题目名称区域（与quiz答题页面一致） */}
          {isCodingQuestion && (
            <div className="mb-3 pb-3 border-b border-gray-200">
              <span className="text-sm font-medium text-gray-500">题目名称：</span>
              <span className="text-base font-semibold text-gray-800">{questionTitle}</span>
            </div>
          )}
          {titleText}
        </div>
      </div>
    </div>
  );
}
